'use strict';

var _commonjsHelpers = require('./_commonjsHelpers-755157d3.js');
var hydrate = require('./hydrate-9df31177.js');
var hydrateRoot = require('./hydrateRoot-17352adc.js');
require('react-dom');
require('./track-fa925b7f.js');
require('./constants-d8339ee1.js');
require('./performance-be581d81.js');
require('./perfill-505e8086.js');
require('react-dom/client');

var app = {exports: {}};

app.exports;
(function (module, exports) {
	var hydrate$1 = hydrate.hydrate_1;
	var hydrateRoot$1 = hydrateRoot.hydrateRoot_1;
	module.exports = hydrate$1;
	exports = module.exports;
	exports.hydrate = hydrate$1;
	exports.hydrateRoot = hydrateRoot$1;
} (app, app.exports));
var appExports = app.exports;
var index = _commonjsHelpers.getDefaultExportFromCjs(appExports);

module.exports = index;
